import React from "react"
import { connect } from "react-redux"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import Transaction from "./Transaction"
import { fetchActiveMeetingTransactions } from "../../../store/actions/meetings"
import { fullArabicDateConverter } from "../../../view/shared/utilities/arabicDateConverter"
import SecondaryLoader from "../../layout/SecondaryLoader"

const dateStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "bolder",
  fontSize: "25px",
  padding: "1.5rem",
  textAlign: "center",
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
}
const View = (props) => {
  const { i18n } = useLingui()
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    const id = props.currentOngoingMeeting?.id
    if (!id) {
      return
    }
    setIsLoading(true)
    props.fetchActiveMeetingTransactions(id).catch(err => console.log(err))
    setTimeout(() => {
      setIsLoading(false)
    }, 500);
  }, [])


  return (
    <div key={props.meetingTransactions?.length} style={{ padding: "12px 14px", width: "100%" }}>
      <div style={dateStyle}>
        <span>
          {!["ar"].includes(i18n.locale) &&
            new Date(props.currentOngoingMeeting?.date).toLocaleString(i18n.locale, { dateStyle: "full" })}
          {["ar"].includes(i18n.locale) &&
            fullArabicDateConverter(props.currentOngoingMeeting?.date)}
        </span>
      </div>
      {!isLoading && !props.meetingTransactions.length ? (
        <div style={{ textAlign: "center" }}>
          <center>
            <br />
            <span style={loadingStyle}>
              <Trans id="no.records.found">No records found</Trans>
            </span>
          </center>
        </div>
      ) : (
        props.meetingTransactions.map((ts) => (
          <span key={ts.status + ts.requestId}>
            <Transaction data={ts} />
            <hr />
          </span>
        ))
      )}
      {isLoading && <SecondaryLoader />}
    </div>
  )
}

View.propTypes = {
  meetingTransactions: PropTypes.array,
  members: PropTypes.array,
  vsla: PropTypes.object,
  currentOngoingMeeting: PropTypes.object,
  fetchActiveMeetingTransactions: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    meetingTransactions: state.meetingTransactions,
    currentOngoingMeeting: state.meeting?.ongoing,
    members: state.loadedvslaMembers,
    isConnected: state.isConnected,
    vsla: state.vsla,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fetchActiveMeetingTransactions: (id) =>
      dispatch(fetchActiveMeetingTransactions(id)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(View)
